import axios from "axios";
import { API_BASE_URL } from "../../../config";

export async function fetchAdminPredictionDesk({
  page = 1,
  limit = 25,
  desk = "all",
  search = "",
  refresh = false,
} = {}) {
  const token = localStorage.getItem("adminToken");
  const params = new URLSearchParams();
  params.set("page", String(page));
  params.set("limit", String(limit));
  if (desk && desk !== "all") params.set("desk", desk);
  if (search) params.set("search", search);
  if (refresh) params.set("refresh", "1");

  const { data } = await axios.get(
    `${API_BASE_URL}/api/website/admin/predictions?${params.toString()}`,
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return data;
}

export async function fetchAdminPredictionDetail(predictionId, { refresh = false } = {}) {
  const token = localStorage.getItem("adminToken");
  const params = new URLSearchParams();
  if (refresh) params.set("refresh", "1");
  const qs = params.toString();

  const { data } = await axios.get(
    `${API_BASE_URL}/api/website/admin/predictions/${predictionId}${qs ? `?${qs}` : ""}`,
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return data;
}
